import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { Utils } from '../../utils/utils';
import { Constant } from '../../../environments/constants';
// import { environment } from '../../environments/environment';
import { AppInsightsService, SeverityLevel } from '@markpieszak/ng-application-insights';
import { User } from './../models';

@Injectable({
  providedIn: 'root'
})
export class AppMonitoringService {

  private sessionId;
  //private email = '';
  private app = "GPT -> ";
  private user: User;
  
  
  constructor(private _httpClient: HttpClient,
    private appInsightsService: AppInsightsService) {
    this.sessionId = (new Date()).getTime();
    this.app += ' Session Id:' + this.sessionId + ' ';  
    appInsightsService.config = {
      instrumentationKey: Constant.config.appInsightKey// <-- set it later sometime
    }
    appInsightsService.init();
  }

  // setEmail(email = '') {
  //   this.email = email;
  // }

  setUser(ur) {
    this.user = ur;
  }

  // getEmail() {
  //   return this.email;
  // }


  // -------- Tracing -------------
  // Information, Verbose, Warning, Error, Critical
  traceMsg(msg: string, detail?: any, level = 'Information'): void {
    if(Constant.config.isAppMonitoringEnabled) {
      this.appInsightsService.trackTrace(this.app + msg, { 'userId': this.user.primaryEmail, 'sessionId': this.sessionId, 'datail': JSON.stringify(detail) }, SeverityLevel[level]);
    }
  }

  traceEvent(msg: string, property?: any): void {
    if(Constant.config.isAppMonitoringEnabled) {
      this.appInsightsService.trackEvent(this.app + msg, property)
    }
  }

  traceException(err: Error): void {
    if(Constant.config.isAppMonitoringEnabled) {
      this.appInsightsService.trackException(err);
    }
  }

  flushMessages() {
    this.appInsightsService.flush();
  }

}
